"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _urlCatalog = _interopRequireDefault(require("@angi/url-catalog"));

var _angieslistAppPlatform = require("angieslist-app-platform");

var _Col = _interopRequireDefault(require("angieslist-react-components/lib/Col"));

var _Row = _interopRequireDefault(require("angieslist-react-components/lib/Row"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icons = require("@angi/icons");

var _headerAnalytics = _interopRequireDefault(require("./headerAnalytics"));

var _angiAdsLeftSideBarItems = _interopRequireDefault(require("./angiAdsLeftSideBarItems"));

var _angiLeadsLeftSideBarItems = _interopRequireDefault(require("./angiLeadsLeftSideBarItems"));

var _angi_logo = _interopRequireDefault(require("../../browser/assets/angi_logo.svg"));

var _a, _p;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var OfficeLeftSideBar = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(OfficeLeftSideBar, _React$Component);

  var _super = _createSuper(OfficeLeftSideBar);

  function OfficeLeftSideBar(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, OfficeLeftSideBar);
    _this = _super.call(this, props);
    _this.state = {
      expandedSubNav: ''
    };
    return _this;
  }

  (0, _createClass2["default"])(OfficeLeftSideBar, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          angiLeadsProperties = _this$props.angiLeadsProperties,
          hasBmt = _this$props.hasBmt,
          isAdmin = _this$props.isAdmin,
          isAdvertiser = _this$props.isAdvertiser,
          leadsNotificationCount = _this$props.leadsNotificationCount,
          spId = _this$props.spId,
          reviewsNotificationCount = _this$props.reviewsNotificationCount,
          isAuth = _this$props.isAuth,
          proType = _this$props.proType,
          closeSideBar = _this$props.closeSideBar,
          isAngiLeadsAdmin = _this$props.isAngiLeadsAdmin;
      var expandedSubNav = this.state.expandedSubNav;

      var openSubNav = function openSubNav(subNav) {
        var newSubNav = expandedSubNav === subNav ? '' : subNav;

        _this2.setState({
          expandedSubNav: newSubNav
        });
      };

      var handleClose = function handleClose() {
        _angieslistAppPlatform.tracker.track('Item Clicked', {
          activityLocation: "".concat(proType === 'Angi Ads' ? 'Ads' : 'Leads', " Auth Header"),
          description: 'Nav menu collapsed'
        });

        closeSideBar();
      };

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "unified-header-side-bar"
      }, /*#__PURE__*/_react["default"].createElement(_Row["default"], {
        className: "separator-bottom-grey side-menu-main-row-wrapper side-menu-main-row-flex-wrapper"
      }, _a || (_a = /*#__PURE__*/_react["default"].createElement("a", {
        href: "/",
        className: "pull-left header--logo-padded",
        id: "header--logo"
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("img", {
        alt: "logo",
        src: _angi_logo["default"],
        className: "header--logo-img"
      })))), /*#__PURE__*/_react["default"].createElement(_icons.LightCloseIcon, {
        className: "left-side-bar--close-icon",
        onClick: handleClose
      })), isAuth ? angiLeadsProperties.isAngiLeads ? /*#__PURE__*/_react["default"].createElement(_angiLeadsLeftSideBarItems["default"], {
        angiLeadsProperties: angiLeadsProperties,
        expandedSubNav: expandedSubNav,
        leadsNotificationCount: leadsNotificationCount,
        openSubNav: openSubNav,
        spId: spId,
        isAngiLeadsAdmin: isAngiLeadsAdmin
      }) : /*#__PURE__*/_react["default"].createElement(_angiAdsLeftSideBarItems["default"], {
        expandedSubNav: expandedSubNav,
        hasBmt: hasBmt,
        isAdmin: isAdmin,
        isAdvertiser: isAdvertiser,
        leadsNotificationCount: leadsNotificationCount,
        openSubNav: openSubNav,
        spId: spId,
        reviewsNotificationCount: reviewsNotificationCount
      }) : [/*#__PURE__*/_react["default"].createElement("div", {
        className: "separator-bottom-grey",
        key: "0"
      }, /*#__PURE__*/_react["default"].createElement(_Row["default"], {
        className: "side-menu-main-row-wrapper side-menu-main-row-flex"
      }, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
        xs: 4,
        className: "side-menu-leads-wrapper"
      }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
        "data-track-description": "Leads",
        href: _urlCatalog["default"].office.join(),
        id: "unified-header-sidebar-nav--join-link"
      }, "Join us"))))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "separator-bottom-grey",
        key: "1"
      }, /*#__PURE__*/_react["default"].createElement(_Row["default"], {
        className: "side-menu-main-row-wrapper side-menu-main-row-flex"
      }, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
        xs: 4,
        className: "side-menu-leads-wrapper"
      }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
        "data-track-description": "Sign in link",
        href: _urlCatalog["default"].office.login(),
        id: "unified-header-sidebar-nav--sign-in-link"
      }, "Sign in"))))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "separator-bottom-grey",
        key: "2"
      }, /*#__PURE__*/_react["default"].createElement(_Row["default"], {
        className: "side-menu-main-row-wrapper side-menu-main-row-flex"
      }, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
        xs: 4,
        className: "side-menu-leads-wrapper"
      }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
        "data-track-description": "Need a pro link",
        href: _urlCatalog["default"].global.angiesListHome(),
        id: "unified-header-sidebar-nav--need-pro-link"
      }, "Need a pro?"))))), /*#__PURE__*/_react["default"].createElement("div", {
        id: "unified-header-side-bar--sub-nav-download-wrapper",
        key: "3"
      }, _p || (_p = /*#__PURE__*/_react["default"].createElement("p", {
        id: "unified-header-side-bar--sub-nav-text"
      }, "Download the app to manage your leads on the go")), /*#__PURE__*/_react["default"].createElement("a", {
        id: "unified-header-side-bar--sub-nav-btn",
        href: _urlCatalog["default"].office.download()
      }, "Download now"))]);
    }
  }]);
  return OfficeLeftSideBar;
}(_react["default"].Component);

var _default = (0, _angieslistAppPlatform.analytics)({
  ruleset: _headerAnalytics["default"]
})(OfficeLeftSideBar);

exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-office-app-common/lib/v1/header/officeLeftSideBar.js
// module id = 3665
// module chunks = 25